import { z } from 'zod';

export const ServiceTierSchema = z.enum(['BASIC', 'PRO']);
export type ServiceTier = z.infer<typeof ServiceTierSchema>;
export const ServiceTierExtendedSchema = z.enum([
  'BASIC',
  'PRO',
  'SINGLE',
]);
export type ServiceTierExtended = z.infer<
  typeof ServiceTierExtendedSchema
>;

export const ProvisioningStatusSchema = z.enum([
  'CREATE_FAILED',
  'CHECKOUT_REQUIRED',
  'PROVISIONING',
  'READY',
  'DELETION_IN_PROGRESS',
]);
export type ProvisioningStatus = z.infer<
  typeof ProvisioningStatusSchema
>;

export const ProvisioningSchema = z.object({
  organisationName: z.string(),
  organisationId: z.string().optional(),
  subscriptionId: z.string().optional(),
  allUsersGroupId: z.string().optional(),
  userSeats: z.number().int().optional(),
  userSeatsUsed: z.number().int().optional(),
  serviceTier: ServiceTierSchema,
  checkoutUrl: z.string().nullable().optional(),
  status: ProvisioningStatusSchema.optional(),
});
export type Provisioning = z.infer<typeof ProvisioningSchema>;

export const PriceSchema = z.object({
  seatPrice: z
    .object({
      amount: z.number(),
      tax: z.string(),
    })
    .optional(),
});
export type Price = z.infer<typeof PriceSchema>;

export const SectorSchema = z.enum([
  'PUBLIC_SECTOR',
  'FINANCIAL_SERVICES',
  'HEALTH_LIFE_SCIENCES',
  'INDUSTRIAL_MANUFACTURING',
  'TECHNOLOGY_DIGITAL_SERVICES',
  'OTHER',
]);
export type Sector = z.infer<typeof SectorSchema>;

export const SectorTranslations: Record<Sector, string> = {
  PUBLIC_SECTOR: 'Öffentlicher Sektor',
  FINANCIAL_SERVICES: 'Finanzdienstleistungen',
  HEALTH_LIFE_SCIENCES: 'Gesundheit & Biowissenschaften',
  INDUSTRIAL_MANUFACTURING: 'Industrie & Fertigung',
  TECHNOLOGY_DIGITAL_SERVICES: 'Technologie & Digitale Dienste',
  OTHER: 'Sonstige',
};

export const JurisdictionSchema = z.enum(['EU', 'NON_EU']);
export type Jurisdiction = z.infer<typeof JurisdictionSchema>;

export const JurisdictionTranslations: Record<Jurisdiction, string> =
  {
    EU: 'Europäische Union (EU)',
    NON_EU: 'Nicht-EU',
  };

export const OrganizationCustomAttributesSchema = z.object({
  jurisdiction: JurisdictionSchema,
  sector: SectorSchema,
});
export type OrganizationCustomAttributes = z.infer<
  typeof OrganizationCustomAttributesSchema
>;
